import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgInstagram = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 3.682c2.71 0 3.03.01 4.1.06 2.75.125 4.035 1.43 4.16 4.159.05 1.07.058 1.39.058 4.1s-.01 3.03-.058 4.1c-.126 2.727-1.407 4.034-4.16 4.159-1.07.05-1.39.06-4.1.06s-3.03-.01-4.1-.06c-2.756-.126-4.034-1.437-4.16-4.16-.048-1.07-.058-1.39-.058-4.1s.01-3.03.059-4.1C3.867 5.17 5.148 3.866 7.9 3.74c1.07-.048 1.39-.058 4.1-.058zm0 3.525a4.793 4.793 0 100 9.586 4.793 4.793 0 000-9.586zm0 7.904a3.11 3.11 0 110-6.221 3.11 3.11 0 010 6.221zm4.983-9.213a1.12 1.12 0 10-.001 2.241 1.12 1.12 0 000-2.24z"
      clipRule="evenodd"
    />
  </svg>
));
SvgInstagram.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgInstagram;
